import React from "react";
import { Link } from "@/components/common/Link";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const partners = [{
  name: "Loxone",
  logo: "https://selected-skink.10web.cloud/wp-content/uploads/2026/03/Loxone_transparent.png?v=a3lcrifz17o",
  alt: "Loxone Partner Logo"
}, {
  name: "Wago",
  logo: "https://selected-skink.10web.cloud/wp-content/uploads/2026/03/GS_transparenter_hintergrund.png?v=dd4dxtt9wtu",
  alt: "Wago Kontakttechnik Logo"
}, {
  name: "G&S Elektro",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557665/img/image_eixcuwnq.png",
  alt: "G&S Elektro Logo"
}];
export default function ZusammenarbeitMitElektrofachbetrieben() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="zusammenarbeit-mit-elektrofachbetrieben" className="dark bg-background text-foreground py-20 sm:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={cn("flex flex-col items-center text-center space-y-8 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <div className="max-w-3xl space-y-4">
            <h2 className="text-3xl font-bold tracking-tight sm:text-4xl text-foreground">
              Regionale Partnerschaft & Schweizer Qualität
            </h2>
            <p className="text-muted-foreground text-lg leading-relaxed">Wir setzen auf Vertrauen, Kompetenz und klare Zusammenarbeit. Als Systemintegrator arbeiten wir eng mit regionalen Elektrofachbetrieben im Oberwallis zusammen, um durchdachte und zuverlässige Lösungen für Wohn- und Gewerbebauten zu realisieren.</p>
          </div>

          <div className="w-full pt-8">
            <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16">
              {partners.map((partner, i) => <div key={i} data-index={i} className={cn("group relative flex items-center justify-center p-6 rounded-xl transition-colors", i === 1 && "bg-white/5")}>
                  {i === 0 ? <Link to="https://www.loxone.com" newTab>
                      <img src={partner.logo} alt={partner.alt} className={cn("opacity-60 transition-all duration-300 group-hover:opacity-100 h-20 sm:h-28", i === 1 && "brightness-150")} />
                    </Link> : <img src={partner.logo} alt={partner.alt} className={cn("opacity-60 transition-all duration-300 group-hover:opacity-100 h-20 sm:h-28", i === 1 && "brightness-150")} />}
                </div>)}
            </div>
          </div>
          
          <div className="pt-4">
            <p className="text-sm text-muted-foreground/60 uppercase tracking-widest font-medium">
              Gemeinsam für Ihren Erfolg
            </p>
          </div>
        </div>
      </div>
    </section>;
}